// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1qvZr","dragIcon":"Choice_dragIcon__zkPpr","left":"Choice_left__1i-q5","input":"Choice_input__1Ibz-"};